import './App.css';
import {Header} from './Components/Header'
import {Footer} from './Components/Footer'
import {Allroutes} from './Routes/Allroutes'

function App() {
  return (
    <>
      <Header/>
      <Allroutes/>
      <Footer/>
    </>
  );
}

export default App;
